import { __awaiter } from '../../../../../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useMemo } from 'react';
import { isEmailWalletConnector } from '@dynamic-labs/multi-wallet';
import { createEmailVerification } from '../../../../data/api.js';
import '@dynamic-labs/sdk-api';
import '../../../../shared/logger.js';
import '@dynamic-labs/iconic';
import { useViewContext } from '../../../../context/ViewContext/ViewContext.js';
import '../../../../utils/constants/colors.js';
import '../../../../shared/consts/index.js';
import { useInternalDynamicContext } from '../../../../context/DynamicContext/useInternalDynamicContext.js';
import { useErrorContext } from '../../../../context/ErrorContext/ErrorContext.js';
import 'react-dom';
import '../../../../components/ShadowDOM/ShadowDOM.js';
import '../../../../context/ThemeContext/ThemeContext.js';
import { Input } from '../../../../components/Input/Input.js';
import 'react-focus-lock';
import '../../../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../../components/Transition/OpacityTransition/OpacityTransition.js';
import { Button } from '../../../../components/Button/Button.js';
import '../../../../components/IconButton/IconButton.js';
import 'ethers';
import { useWalletItemActions } from '../../../../utils/hooks/useWalletItemActions/useWalletItemActions.js';
import '../../../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import { useConnectWithEmail } from '../../../../utils/hooks/useConnectWithEmail/useConnectWithEmail.js';
import { useEmailVerificationContext } from '../../../../context/EmailVerificationContext/EmailVerificationContext.js';
import { useLoadingContext } from '../../../../context/LoadingContext/LoadingContext.js';

const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
const LoginWithEmailForm = () => {
    const { environmentId, wallets } = useInternalDynamicContext();
    const { setView } = useViewContext();
    const { loading, setLoading } = useLoadingContext();
    const { setErrorMessage } = useErrorContext();
    const { setEmail: setEmailForVerification, setVerificationUUID } = useEmailVerificationContext();
    const [emailInput, setEmailInput] = useState('');
    const [emailError, setEmailError] = useState(false);
    const emailWalletConnector = wallets
        .map(({ walletConnector }) => walletConnector)
        .find(isEmailWalletConnector);
    const { handleInstalledExtensionClick } = useWalletItemActions();
    const { connectWithEmail, email: magicEmail, setEmail: setEmailForMagic, loading: isMagicLoading, } = useConnectWithEmail({
        emailWalletConnector,
        handleConnect: handleInstalledExtensionClick,
    });
    const isLoading = useMemo(() => isMagicLoading || loading, [isMagicLoading, loading]);
    const handleMagicOnChangeEvent = (event) => {
        const { value } = event.currentTarget;
        setEmailForMagic(value);
    };
    const handleEmailOnChangeEvent = (event) => {
        const { value } = event.currentTarget;
        setEmailInput(value);
    };
    const handleMagicLinkSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        yield connectWithEmail();
    });
    const handleEmailLoginSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        const { email, verificationUUID } = yield createEmailVerification({
            email: emailInput,
            environmentId,
        });
        setView('login-with-email-verification');
        setEmailForVerification(email);
        setVerificationUUID(verificationUUID);
    });
    const magicLinkEnabled = emailWalletConnector !== undefined;
    const submitHandler = magicLinkEnabled
        ? handleMagicLinkSubmit
        : handleEmailLoginSubmit;
    const onChangeHandler = magicLinkEnabled
        ? handleMagicOnChangeEvent
        : handleEmailOnChangeEvent;
    const emailValue = magicLinkEnabled ? magicEmail : emailInput;
    const handleSubmit = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        if (!EMAIL_REGEX.test(emailValue)) {
            setEmailError(true);
            return;
        }
        try {
            setLoading(true);
            yield submitHandler();
        }
        catch (error) {
            setErrorMessage(error.code);
        }
        finally {
            setLoading(false);
        }
    });
    return (jsxs("form", Object.assign({ className: 'login-with-email-form', onSubmit: (e) => handleSubmit(e) }, { children: [jsx(Input, { id: 'email_field', value: emailValue, onChange: onChangeHandler, label: 'Enter your email', error: emailError, message: emailError && 'Please enter a valid email address' }), jsx(Button, Object.assign({ buttonClassName: 'login-with-email-form__button', type: 'submit', loading: isLoading, disabled: isLoading, buttonVariant: 'primary', buttonPadding: 'large', buttonRounded: 'medium', expanded: true }, { children: "Continue" }))] })));
};

export { EMAIL_REGEX, LoginWithEmailForm };
